import { render, staticRenderFns } from "./formula-department.vue?vue&type=template&id=e168f3bc&"
import script from "./formula-department.vue?vue&type=script&lang=js&"
export * from "./formula-department.vue?vue&type=script&lang=js&"
import style0 from "./formula-department.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports